<template>
  <v-card>
    <v-card-title>
      {{ $t('admin_acc_booking.add_additional_item_title') }}
    </v-card-title>
    <v-card-text>
      <v-form ref="additionalItemForm" class="admin-add-additional-item-dialog-form">
        <div v-for="(item, index) in additionalItems"
             :class="['additional-item', {'mobile': $vuetify.breakpoint.smAndDown}]"
             :key="item.id">
          <div class="additional-item-label">
            <v-img :src="'api/static/' + item.icon"
                   contain
                   max-width="100px"
                   max-height="100px"></v-img>
            <span class="flex-grow-1 text-left">
                    <b>{{ item.name }}</b>
                  </span>
          </div>
          <div class="addition-item-input-div">
            <span class="additional-item-price">${{ item.price }}</span>
            <v-text-field type="number"
                          v-model="selectedAdditionalItems[item.id]"
                          hide-details
                          min="0"
                          :max="item.max_per_booking"
                          class="additional-item-input"
                          dense
                          solo
                          autocomplete="off">
              <template #prepend>
                <v-btn icon
                       x-small
                       :disabled="selectedAdditionalItems[item.id] === 0"
                       @click="minusAdditionalItem(item)">
                  <v-icon x-small>fas fa-minus</v-icon>
                </v-btn>
              </template>
              <template #append v-if="item.max_per_booking !== -1">
                <span class="small">/ {{ item.max_per_booking }}</span>
              </template>
              <template #append-outer>
                <v-btn icon
                       x-small
                       :disabled="selectedAdditionalItems[item.id] >= item.max_per_booking"
                       @click="addAdditionalItem(item)">
                  <v-icon x-small>fas fa-plus</v-icon>
                </v-btn>
              </template>
            </v-text-field>
            <span class="additional-item-price"><b>${{ item.price * selectedAdditionalItems[item.id] }}</b></span>
          </div>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-spacer></v-spacer>
      <v-btn text
             @click="$emit('submit', undefined)">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn text
             color="primary"
             :disabled="!canSubmit"
             @click="$emit('submit', selectedAdditionalItems)">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import {computed, onMounted, ref} from "@vue/composition-api";
import _ from "lodash";

export default {
  name: 'AdminAddAdditionalItemDialog',
  props: {
    additionalItems: Array,
  },
  setup(props, {root}) {
    const selectedAdditionalItems = ref({});
    const minusAdditionalItem = function (item) {
      selectedAdditionalItems.value[item.id] = Math.max(selectedAdditionalItems.value[item.id] - 1, 0);
    }
    const addAdditionalItem = function (item) {
      selectedAdditionalItems.value[item.id] = Math.min(selectedAdditionalItems.value[item.id] + 1, item.max_per_booking);
    }
    const canSubmit = computed(()=> {
      return _.some(Object.keys(selectedAdditionalItems.value), (k) => {
        return selectedAdditionalItems.value[k] > 0;
      })
    })

    onMounted(() => {
      let d = {};
      props.additionalItems.forEach((item) => {
        d[item.id] = 0;
      })
      selectedAdditionalItems.value = d;
    })

    return {
      selectedAdditionalItems,
      minusAdditionalItem,
      addAdditionalItem,
      canSubmit,
    }
  }
}
</script>

<style lang="less">
.admin-add-additional-item-dialog-form {
  .additional-item {
    width: 100%;
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    padding-bottom: 16px;

    &.mobile {
      flex-direction: column;
      align-items: stretch;
    }

    .additional-item-label {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      width: 300px;
      padding: 8px;

      .v-image {
        margin: 0 !important;
      }
    }

    .addition-item-input-div {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      padding: 0 8px;
      min-width: 200px;

      .additional-item-price {
        flex: 1 1 0;
        min-width: 48px;
      }

      .additional-item-input {
        margin-left: 24px !important;
        margin-right: 24px !important;

        input {
          text-align: center;
        }

        /* Chrome, Safari, Edge, Opera */

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */

        input[type=number] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
